<snelstart-ui-button (click)="this.showDialog()"
                     class="custom-input-150"
                     icon="plus"
                     type="secondary">Specificeer
</snelstart-ui-button>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="lg" size="xl"
                                title="Specificatie egalisatiereserve">
    <snelstart-ui-dialog-body>
        <div class="ps-2">
            <form [formGroup]="specEgalisatiereserveFG">
                <div class="row">
                    <div class="col col-7">
                        <p>Bedrag volgens openingsbalans</p>
                    </div>
                    <div class="col-5">
                        <snelstart-ui-number-form-control (change)="saveForm()"
                                                          [decimals]="0"
                                                          [disabledControl]=" true"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="waardeOpening"
                                                          prefix="€"

                        >
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4"></div>
                </div>
            </form>

            <form [formGroup]="ondernemingFG">
                <ng-container formArrayName="ondernemingen">
                    <ng-container *ngFor="let onderneming of ondernemingen.controls; let i = index "
                                  [formGroupName]="i">
                        <div class="row">
                            <div class="col col-7">
                                <p>Bij: Dotatie</p>
                            </div>
                            <div class="col-5">
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  align="right"
                                                                  class="custom-input-150"
                                                                  formControlName="dotatieEgalisatiereserve"
                                                                  id="dotatieKER"
                                                                  prefix="€"


                                >
                                </snelstart-ui-number-form-control>
                            </div>
                            <div class="col-4"></div>
                        </div>
                        <div class="row">
                            <div class="col col-17">
                                <p>Af: Onttrekking</p>
                            </div>
                            <div class="col-5">
                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                  [decimals]="0"
                                                                  align="right"
                                                                  class="custom-input-150"
                                                                  formControlName="vrijvalEgalisatiereserve"
                                                                  id="vrijvalHIR"
                                                                  prefix="€ -"

                                >
                                </snelstart-ui-number-form-control>
                            </div>
                            <div class="col-4"></div>
                        </div>
                    </ng-container>
                </ng-container>
            </form>
            <form [formGroup]="specEgalisatiereserveFG">
                <div class="row">
                    <div class="col col-7">
                        <p>Bedrag volgens slotbalans</p>
                    </div>
                    <div class="col-5">
                        <snelstart-ui-number-form-control (change)="saveForm()"
                                                          [decimals]="0"
                                                          [disabledControl]=" true"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="waardeSlot"
                                                          prefix="€"


                        >
                        </snelstart-ui-number-form-control>
                    </div>
                    <div class="col-4"></div>
                </div>
            </form>


            <div *ngIf="this.specEgalisatiereserveFG.get('waardeOpening')?.value > 0">

                <hr class="line-color pt-2">

                <p><b>1. Specificeer de egalisatiereserve volgens openingsbalans</b></p>

                <form [formGroup]="ondernemingFG">
                    <div class="row">
                        <ng-container formArrayName="ondernemingen">
                            <ng-container
                                    *ngFor="let onderneming of ondernemingen.controls; let i = index "
                                    [formGroupName]="i">
                                <div class="row">
                                    <ng-container formArrayName="beginstandEgalisatiereserve">
                                        <ng-container
                                                *ngFor="let item of getBeginstandKER(i).controls; let k = index; "
                                                [formGroupName]="k">
                                            <div>
                                                <snelstart-ui-text-form-control (change)="saveForm()"
                                                                                [label]="k === 0 ? 'Omschrijving toekomstige kosten' : ''"
                                                                                class="custom-input-250"
                                                                                formControlName="omschrijving"
                                                                                id="omschrijving"
                                                >
                                                </snelstart-ui-text-form-control>
                                                <snelstart-ui-number-form-control (change)="saveForm()"
                                                                                  [decimals]="0"
                                                                                  [label]="k === 0 ? 'Bedrag' : ''"
                                                                                  align="right"
                                                                                  class="custom-input-150"
                                                                                  formControlName="bedrag"
                                                                                  id="bedrag"
                                                                                  prefix="€"

                                                >
                                                </snelstart-ui-number-form-control>
                                                <snelstart-ui-button (click)="deleteBeginstandKER(i, k)"
                                                                     [class]="k === 0 ? 'pt-3' : ''"
                                                                     class="delete"
                                                                     iconType="light"
                                                                     id="buttonDelete"
                                                                     size="medium"
                                                                     type="secondary"
                                                >
                                                </snelstart-ui-button>
                                            </div>
                                        </ng-container>
                                    </ng-container>
                                    <div>
                                        <div *ngIf="getBeginstandKER(i).length === 0">
                                            <snelstart-ui-button (click)="addBeginstandKER(i)"
                                                                 class="snelstart-ui-button pb-3" icon="plus"
                                                                 id="cancelA"
                                                                 type="link">Toekomstige kosten invullen
                                            </snelstart-ui-button>
                                        </div>
                                        <div *ngIf="getBeginstandKER(i).length !== 0">
                                            <snelstart-ui-button (click)="addBeginstandKER(i)"
                                                                 class="snelstart-ui-button pb-3" icon="plus"
                                                                 id="cancelB"
                                                                 type="link">Toekomstige kosten toevoegen
                                            </snelstart-ui-button>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </form>

                <div *ngIf="getTotaalBedragen() > 0 && specEgalisatiereserveFG.get('waardeOpening')?.value !== getTotaalBedragen()"
                     class="pb-2">
                    <snelstart-ui-alert type="info">
                        Het bedrag van de slotbalans volgens bovenstaande specificatie
                        (€ {{ getTotaalBedragen() | number:'1.0-0' }}) is (nog) niet gelijk aan het bedrag dat op de
                        balans
                        vermeld is (€ {{ specEgalisatiereserveFG.get('waardeOpening')?.value | number:'1.0-0' }}).
                    </snelstart-ui-alert>
                </div>
            </div>

        </div>

    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex mt-2">
        <snelstart-ui-button btn-x class="me-2" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button [submit]="true" icon="check" id="save" type="primary">Opslaan</snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
